module.exports = {"name":"azuremediaplayer","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-06-12","repo":"https://bitbucket.org/npaw/azuremediaplayer-adapter-js","libVersion":"6.2.6","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0